<template>
  <Item
    v-if="brand" 
    model="brand" 
    :item="brand"
    :prev="prev"
    :next="next"
    :nextUrl="nextUrl"
    :status="status"
    @onFetchMore="updateItems"
    @onRemoveItem="removeItem"
  >
    <GroupCard
      :key="item.slug"
      v-for="item in groupings"
      :user="currentUser"
      :item="item"
    />
  </Item>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapState,
} from 'vuex';
import { showPrompt } from '../../utils/helpers'
import Item from '../../layouts/Item/Item';
import GroupCard from '../../components/GroupCard/GroupCard';

export default {
  name: 'Brand',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      num: 12
    };
  },
  components: {
    GroupCard,
    Item,
  },
  async mounted() {
    // fetch this even if the brand getter returns a brand
    // we need to make sure that we fetch the brand's groupigs and prev/next
    await this.fetchBrand(this.slug, this.num);
    // console.log(this.$store)
  },
  computed: {
    ...mapGetters('brand', ['getBySlug']),
    ...mapGetters('grouping', ['getGroupsByBrand']),
    ...mapState('currentUser', ['currentUser']),
    ...mapState('brand', ['status']),
    brand() {
      return this.getBySlug(this.slug)
    },
    prev() {
      return this.brand.prev;
    },
    next() {
      return this.brand.next;
    },
    nextUrl() {
      return this.brand.nextUrl;
    },
    groupings() {
      // return []
      return this.getGroupsByBrand(this.slug)
    }
  },
  methods: {
    ...mapActions('brand', [
      'FETCH',
      'FETCH_MORE_GROUPINGS',
      'REMOVE',
    ]),
    async fetchBrand(slug, num) {
      const { brand, groupings } = await this.FETCH({ slug, num, });

      console.log('brand', brand);
      console.log('groupings', groupings);
    },
    updateItems() {
      this.FETCH_MORE_GROUPINGS({
        slug: this.slug,
        url: this.brand.nextUrl
      });
    },
    removeItem() {
      showPrompt();

      this.REMOVE({ slug: this.slug });
    },
  },
  watch: {
    async $route() {
      await this.fetchBrand(this.slug, this.num);
    }
  }
};
</script>

